import { Component, View, ViewModel } from "binder";
import  { DateSelectorView } from "./dateSelector-view"
import { getAsBoolean } from "../utilities";

export class DateSelectorViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.dateselector = true;
        this.timeselector = false;
        this.opentop = false;
        this.allowclear = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new DateSelectorView();
    }
    public getTypeId(): string {
        return "VM-269194FD-7350-44E5-BA77-3C6339E4DB07"
    }

    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date;} private _date: moment.Moment;
    public set startwithyear(v: boolean) { 
        this._startwithyear = (v==true || (<any>v=="true")); 
    } public get startwithyear(): boolean { return this._startwithyear;} private _startwithyear: boolean;
    public set opentop(v: boolean) { this._opentop = v; } public get opentop(): boolean { return this._opentop;} private _opentop: boolean;
    public set allowclear(v: boolean) { this._allowclear = v; } public get allowclear(): boolean { return this._allowclear;} private _allowclear: boolean;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;
    public set timeselector(v: boolean) { this._timeselector = getAsBoolean(v); } public get timeselector(): boolean { return this._timeselector;} private _timeselector: boolean;
    public set dateselector(v: boolean) { this._dateselector = getAsBoolean(v); } public get dateselector(): boolean { return this._dateselector;} private _dateselector: boolean;
    
}
